import { render, staticRenderFns } from "./ques-outerForm.vue?vue&type=template&id=a267f30a&scoped=true"
import script from "./ques-outerForm.vue?vue&type=script&lang=js"
export * from "./ques-outerForm.vue?vue&type=script&lang=js"
import style0 from "./ques-outerForm.vue?vue&type=style&index=0&id=a267f30a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a267f30a",
  null
  
)

export default component.exports